export default {
  "labels": {
    "distraction": "Distractions",
    "moreSevereSpeedingLength": "Very serious speed excess",
    "morningSpeedingLength": "Daytime speed excess",
    "severeSpeedingLength": "Serious speed excess",
    "nightSpeedingLength": "Nighttime speed excess",
    "fov": "FOV"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/behavior/behaviorIndicators.js